import { Box, DialogContentText, DialogTitle, IconButton, styled, Typography } from '@mui/material';

import { colors } from '../../../../theme';

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        width: '440px'
    }
};

export const StyledDialogTitle = styled(DialogTitle)({
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '16px',
    fontFamily: 'Inter'
});

export const CloseButton = styled(IconButton)({
    position: 'absolute',
    right: 12,
    top: 12,
    color: colors.white70
});

export const CloseIcon = styled(Typography)({
    fontSize: '16px',
    fontWeight: 'bold'
});

export const SectionTitle = styled(Typography)({
    color: colors.white50,
    fontSize: '16px',
    marginBottom: '8px',
    textAlign: 'left'
});

export const Description = styled(DialogContentText)({
    color: colors.white70,
    textAlign: 'left',
    marginBottom: '30px'
});

export const MarkdownContainer = styled(Box)({
    marginBottom: '30px',
    textAlign: 'left',
    '& .wmde-markdown': {
        backgroundColor: 'transparent',
        color: colors.white70,
        fontFamily: 'Inter',
        fontSize: '14px',
        '& a': {
            color: colors.orangeyYellow,
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
                color: colors.yellow60
            },
            
            '&:visited': {
                color: colors.pirateGold
            }
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: colors.white90
        },
        '& code': {
            backgroundColor: colors.blueBlack,
            color: colors.white90
        },
        '& pre': {
            backgroundColor: colors.blueBlack
        }
    }
});

export const FilesContainer = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px'
});

export const FileItem = styled(Box)({
    display: 'flex',
    alignItems: 'center'
});

export const FileLink = styled('a')({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    gap: '8px'
});

export const FileLinkContent = styled(Typography)({
    fontSize: '13px',
    fontWeight: '400',
    backgroundColor: colors.blueBlack,
    borderRadius: '50px',
    padding: '8px 15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white
});

export const IconSpacer = styled('span')({
    marginLeft: '10px'
});
